<!--
 * @Description: 进度与成果Item
 * @Author: black-k
 * @Date: 2025-09-09 14:38:26
 * @LastEditors: black-k
 * @LastEditTime: 2025-09-22 13:13:26
-->
<template>
    <div class="process-item">
        <div class="process-item_header">
            <div class="header-info">
                <img :src="getAvatar(result.user_info?.head_portrait)" alt="" />

                <div class="info-detail">
                    <div class="detail-company">
                        <h2>{{ result.user_info?.name }}</h2>

                        <span :class="['detail-result', `detail-result-${result.type}`]">
                            {{ resultTypeLabelMap[result.type] }}
                        </span>

                        <!-- 返工，完成任务 -->
                        <template v-if="[5, 6].includes(result.type)">
                            <h2>{{ result.target_user_info?.name }}</h2>

                            <span :class="['detail-result', `detail-result-${result.type}`]" v-if="result.type === 6"> 完成了任务 </span>
                        </template>
                    </div>

                    <div class="detail-time">{{ result.update_time }}</div>
                </div>
            </div>
        </div>

        <!-- 终止合同 -->
        <div class="process-item_end" v-if="[3, 5].includes(result.type)">
            <div class="end-box">
                <div class="end-label">
                    <i class="el-icon-warning"></i>
                    {{ endLabel[result.type] }}:
                </div>

                <div class="end-desc">
                    <div class="desc-item" v-for="(item, index) in result.content?.description?.split('\n')" :key="index">
                        {{ item }}
                    </div>
                </div>
            </div>
        </div>

        <!-- 企业验收任务 -->
        <div class="process-item_pass" v-else-if="result.type === 6">
            <div class="detail-item desc" style="padding-left: 60px">
                <div class="detail-item_label">验收评分：</div>

                <div class="detail-item_value">
                    <i :class="['iconfont rating-icon', { light: item <= result?.content?.rating }]" v-for="item in 5" :key="item">
                        &#xe7e7;
                    </i>
                </div>
            </div>

            <div class="pass-box">
                <div class="pass-label">
                    <i class="el-icon-success"></i>
                    验收意见:
                </div>

                <div class="pass-desc">
                    <div class="desc-item" v-for="(item, index) in result.content?.evaluation_content?.split('\n')" :key="index">
                        {{ item }}
                    </div>
                </div>
            </div>
        </div>

        <!-- 学生评价任务 -->
        <div class="process-item_rate" v-else-if="result.type === 7">
            <div class="detail-item desc">
                <div class="detail-item_label">评分：</div>

                <div class="detail-item_value">
                    <i :class="['iconfont rating-icon', { light: item <= result?.content?.rating }]" v-for="item in 5" :key="item">
                        &#xe7e7;
                    </i>
                </div>
            </div>

            <div class="detail-item desc">
                <div class="detail-item_label">评价：</div>

                <div class="detail-item_value">
                    <div class="desc-item" v-for="(item, index) in result.content?.evaluation_content?.split('\n')" :key="index">
                        {{ item }}
                    </div>
                </div>
            </div>
        </div>

        <!-- 进度内容 -->
        <div class="process-item_content" v-else>
            <!-- 描述 -->
            <div class="detail-item desc">
                <div class="detail-item_label">说明：</div>
                <div class="detail-item_value">
                    <div class="desc-empty" v-if="!result?.content?.description">无说明内容</div>

                    <div class="desc-ol" v-else>
                        <div class="ol-item" v-for="item in result?.content?.description.split('\n')">
                            {{ item }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 链接 -->
            <div class="detail-item link" v-if="result?.content?.urls?.length > 0">
                <div class="detail-item_label">链接：</div>

                <div class="detail-item_value">
                    <div class="link-item" v-for="link in result?.content?.urls" @click="handleLink(link)">
                        <el-link type="primary">
                            <i class="el-icon-link"></i>
                            {{ link.name }}
                        </el-link>
                    </div>
                </div>
            </div>

            <!-- 附件 -->
            <div class="detail-item files" v-if="result?.content?.files?.length > 0">
                <div class="detail-item_label">附件：</div>

                <div class="detail-item_value">
                    <ul class="files-ul">
                        <li v-for="(file, index) in result?.content?.files" :key="index" @click="handleDown(file)">
                            <img :src="getIcon(file.file_name)" alt="" />
                            {{ file.file_name }}

                            <i class="el-icon-download"></i>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div :class="['process-point', { first: first }]"></div>
        <div :class="['process-line', { first: first, last: last }]"></div>
    </div>
</template>

<script>
import { downloadFile, getFileIcon, getFileUnit } from "@/utils/common";

export default {
    data() {
        return {
            resultTypeLabelMap: {
                1: "发起合同表单",
                2: "完成合同表单",
                3: "终止合同签约",
                4: "发起验收表单",
                5: "将任务返工", // 返工
                6: "确认了", // 企业验收通过
                7: "完成了评价", // 学生评价
            },

            endLabel: {
                3: "终止说明",
                5: "返工理由",
            },
        };
    },

    props: {
        result: {
            type: Object,
            required: true,
        },

        first: {
            type: Boolean,
            default: false,
        },

        last: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        // 获取头像
        getAvatar(avatar) {
            return avatar || require("@/assets/img/image/user_img.png");
        },

        // 获取文件Icon
        getIcon(name) {
            return getFileIcon(getFileUnit(name));
        },

        // 下载文件
        async handleDown(file) {
            downloadFile(file.file_url, file.file_name);
        },

        // 打开链接
        handleLink(link) {
            window.open(link.url, "_blank");
        },
    },
};
</script>

<style lang="scss" scoped>
.process-item {
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e9e9e9;
    position: relative;

    & + .process-item {
        margin-top: 40px;
    }

    &_header {
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e9e9e9;
        background-color: #fafafa;

        .header-info {
            display: flex;
            align-items: center;
            gap: 20px;

            img {
                width: 60px;
                height: 60px;
                object-fit: cover;
                border-radius: 4px;
            }

            .info-detail {
                .detail-company {
                    display: flex;
                    align-items: center;
                    gap: 4px;

                    h2,
                    div,
                    span {
                        font-weight: 500;
                        font-size: 14px;
                    }

                    .detail-result {
                        color: #ff8a00;

                        &.detail-result-3,
                        &.detail-result-5 {
                            color: #ff3c25;
                        }

                        &.detail-result-2,
                        &.detail-result-6,
                        &.detail-result-7 {
                            color: #9acc5b;
                        }
                    }
                }

                .detail-time {
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                }
            }
        }
    }

    &_end,
    &_pass {
        padding: 20px 40px;

        .end-box,
        .pass-box {
            border-radius: 4px;
            display: flex;
            padding: 14px 18px;
            font-weight: 400;
            font-size: 14px;
            color: #333a40;

            .end-label,
            .pass-label {
                flex-shrink: 0;
            }
        }

        .end-box {
            background: #fff2f2;
            border: 1px solid #ff9595;

            i {
                color: #ff3c3c;
            }
        }

        .pass-box {
            margin-top: 16px;
            background: #f3fffb;
            border: 1px solid #7cc322;

            i {
                color: #9acc5b;
            }
        }

        .desc-item {
            min-height: 20px;
        }
    }

    &_content {
        padding: 20px 40px 20px 100px;
    }

    &_rate {
        padding: 20px 40px 20px 100px;
    }

    .detail-item {
        & + .detail-item {
            margin-top: 20px;
        }

        display: flex;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;

        &_label {
            flex-shrink: 0;
        }

        &.money {
            .detail-item_value {
                color: #ff8a00;
            }
        }

        &.desc {
            .desc-empty {
                font-weight: 400;
                color: #999999;
            }

            .desc-ol {
                padding: 0;
                margin: 0;

                .ol-item {
                    min-height: 20px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                }
            }
        }

        &.link {
            ::v-deep(.el-link) {
                color: #1890ff;
                display: flex;
                justify-content: flex-start;
            }
        }

        &.files {
            .files-ul {
                li {
                    & + li {
                        margin-top: 16px;
                    }

                    display: flex;
                    align-items: center;
                    gap: 3px;
                    color: #1890ff;
                    font-weight: 400;
                    font-size: 14px;
                    cursor: pointer;

                    .el-icon-download {
                        font-size: 20px;
                        margin-left: 7px;
                        font-weight: bold;
                    }
                }
            }
        }
    }

    .rating-icon {
        color: #e4e4e4;
        line-height: 16px;

        & + .iconfont {
            margin-left: 5px;
        }

        &.light {
            color: #fcbd09;
        }
    }

    .process-point {
        position: absolute;
        width: 16px;
        height: 16px;
        background: linear-gradient(270deg, #2338e6 100%, #4f61f1 0%), #d9d9d9;
        border-radius: 50%;
        left: -30px;
        top: 40px;

        &.first {
            width: 12px;
            height: 12px;
            background: #ffffff;
            border: 1px solid #594fee;
            box-shadow: 0px 0px 0px 6px rgba(89, 79, 238, 0.2);
            left: -29px;
        }
    }

    .process-line {
        position: absolute;
        width: 2px;
        height: calc(100% + 40px - 10px);
        background: #594fee;
        left: -23px;
        top: 56px;

        &.last {
            display: none;
        }

        &.first {
            top: 60px;
        }
    }
}
</style>
